import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GreenTrue, CartPlus } from "../../Images/svgs";

function HeaderCampaign() {
  // These would ideally come from props in a real scenario
  const target = 100000;
  const raised = 66200;
  const progressPercent = (raised / target) * 100;

  return (
    <section className="container max-w-7xl mx-auto mt-10 px-4 lg:px-0">
      <div className="relative overflow-hidden rounded-2xl min-h-[400px] flex items-center shadow-xl">
        {/* Background Image with Gradient Overlay */}
        <div className="absolute inset-0 z-0">
          <LazyLoadImage
            alt="Campaign Header"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/306478ad2f4728d4b63e00a0b2f886a0ca6abf7145f707ccb8ad36ab887bc297"
            className="object-cover w-full h-full"
          />
          {/* Gradient makes text readable regardless of image brightness */}
          <div className="absolute inset-0 bg-gradient-to-l from-black/60 via-black/20 to-transparent" />
        </div>

        {/* Content Container */}
        <div
          className="relative z-10 w-full flex flex-col lg:flex-row justify-between items-center px-8 lg:px-16 py-12 gap-8"
          dir="rtl"
        >
          {/* Right Side: Title/Call to Action Area (Optional) */}
          <div className="flex-1 text-white text-right">
            <h1 className="text-3xl lg:text-5xl font-black mb-4 leading-tight">
              ساعد في بناء <br />{" "}
              <span className="text-amber-400">مستقبل أفضل</span>
            </h1>
            <p className="text-lg opacity-90 max-w-md">
              مساهمتك اليوم هي الأمل لغدٍ مشرق. انضم إلينا في هذه الحملة
              المباركة.
            </p>
          </div>

          {/* Left Side: Ultra-Compact Donation Input */}
          <div
            className="flex relative flex-col p-4 bg-white rounded-2xl border border-zinc-200 shadow-lg w-full max-w-[400px] my-auto ml-auto lg:ml-0"
            dir="rtl"
          >
            {/* Top Info: Title & Last Donation */}
            <div className="flex justify-between items-start mb-4">
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 shrink-0 text-green-600">
                  <GreenTrue />
                </div>
                <span className="text-lg font-bold text-zinc-900 leading-none transition-colors group-hover:text-blue-600">
                  تجوز الزكاة
                </span>
              </div>
              <span className="text-[10px] text-zinc-400 font-medium bg-zinc-50 px-2 py-1 rounded-md border border-zinc-100">
                آخر تبرع قبل ساعتين
              </span>
            </div>

            {/* Progress Tracking (Minimalist) */}
            <div className="flex flex-col mb-5">
              <div className="flex justify-between items-center mb-2">
                <span className="text-xl font-black text-blue-700 tracking-tight">
                  $66,200
                </span>
                <span className="text-xs text-zinc-400 font-medium">
                  من أصل $100,000
                </span>
              </div>
              <div className="w-full h-1.5 bg-zinc-100 rounded-full overflow-hidden">
                <div
                  className="h-full bg-blue-600 rounded-full transition-all duration-1000 shadow-[0_0_8px_rgba(37,99,235,0.4)]"
                  style={{ width: "66.2%" }}
                />
              </div>
            </div>

            {/* INTEGRATED ACTION BAR (The Space-Saver) */}
            <div className="flex items-center p-1 bg-zinc-50 border border-zinc-200 rounded-xl focus-within:border-blue-500 focus-within:bg-white transition-all shadow-inner">
              {/* Value Input */}
              <div className="grow flex items-center px-3 gap-1">
                <span className="text-zinc-400 text-xs font-bold leading-none">
                  $
                </span>
                <input
                  type="number"
                  placeholder="أدخل القيمة"
                  className="w-full bg-transparent outline-none text-right font-bold text-zinc-700 text-sm py-2"
                />
              </div>

              {/* Action Buttons Group */}
              <div className="flex items-center gap-1.5 mr-1">
                {/* Cart Icon (Small & Subtle) */}
                <button className="flex items-center justify-center p-2 text-zinc-400 hover:text-blue-600 hover:bg-white rounded-lg transition-all active:scale-90 border border-transparent hover:border-zinc-100">
                  <CartPlus className="w-5 h-5" />
                </button>

                {/* The Main "Donate Now" Button inside the input */}
                <button className="bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold px-5 py-2.5 rounded-lg shadow-md shadow-blue-200 transition-all active:scale-95 whitespace-nowrap">
                  تبرع الآن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeaderCampaign;
